import React, { memo, useState, useEffect } from 'react';
import '../ShowItemsSelect/show-items-select.scss';

const ShowItemsSelectPageCount = memo(({ options, wrapClass, change, statePageRange }) => {
  const [value, setValue] = useState(options[0].value);

  useEffect(() => {
    setValue(statePageRange);
  }, [statePageRange]);

  const handleChange = (e) => {
    setValue(e.target.value);
    change(e.target.value);
  };

  return (
    <div className={wrapClass}>
      <select className="select-small" onChange={handleChange} value={value}>
        {options.map((option, i) => (
          <option value={option.value} key={i}>
            {option.text}
          </option>
        ))}
      </select>
    </div>
  );
});

export default ShowItemsSelectPageCount;
